import { render } from "./FolderDisplay.vue?vue&type=template&id=05d10674&scoped=true"
import script from "./FolderDisplay.vue?vue&type=script&lang=js"
export * from "./FolderDisplay.vue?vue&type=script&lang=js"

import "./FolderDisplay.vue?vue&type=style&index=0&id=05d10674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d10674"],['__file',"src/components/FolderDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05d10674"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05d10674', __exports__)) {
    api.reload('05d10674', __exports__)
  }
  
  module.hot.accept("./FolderDisplay.vue?vue&type=template&id=05d10674&scoped=true", () => {
    api.rerender('05d10674', render)
  })

}


export default __exports__